export type AuthErrorContext = "login" | "registration" | "invitation" | "governance";

export type AuthErrorLike = {
  code?: unknown;
  message?: unknown;
};

function errorCode(reason: unknown) {
  if (!reason || typeof reason !== "object") return "";
  const candidate = reason as AuthErrorLike;
  if (typeof candidate.code === "string") return candidate.code;
  if (typeof candidate.message === "string" && /^[A-Z][A-Z0-9_]+$/.test(candidate.message)) return candidate.message;
  return "";
}

export function authErrorMessageKey(reason: unknown, context: AuthErrorContext) {
  const code = errorCode(reason);
  if (["auth/invalid-credential", "auth/wrong-password", "auth/user-not-found", "auth/invalid-login-credentials"].includes(code)) {
    return "auth.invalidCredentials";
  }
  if (code === "auth/email-already-in-use") return "auth.accountExists";
  if (code === "auth/weak-password") return "auth.weakPassword";
  if (code === "auth/invalid-email") return "auth.invalidEmail";
  if (["auth/network-request-failed", "auth/too-many-requests"].includes(code)) return code === "auth/too-many-requests" ? "auth.tooManyRequests" : "auth.networkError";
  if (["INVITATION_NOT_FOUND", "INVITATION_EXPIRED", "INVITATION_ALREADY_USED"].includes(code)) return "auth.invitationInvalid";
  if (code === "INVITATION_EMAIL_MISMATCH" || code === "ACCOUNT_EMAIL_MISMATCH") return "auth.invitationEmailMismatch";
  if (code === "ACCOUNT_ALREADY_ASSIGNED") return "auth.accountAssigned";
  if (code === "INVALID_INVITATION_ACCEPTANCE") return "auth.invitationChecksMissing";
  if (code === "SITE_ID_ALREADY_EXISTS") return "auth.siteIdExists";
  if (context === "invitation") return "auth.invitationFailed";
  if (context === "registration") return "auth.registrationFailed";
  if (context === "governance") return "auth.acceptanceFailed";
  return "auth.loginFailed";
}

export function isExistingAccountError(reason: unknown) {
  return errorCode(reason) === "auth/email-already-in-use";
}
